/**
 * CVO Inbox View
 * Dedicated route component for CVO inbox notifications
 */

import React, { useState, useEffect } from 'react';
import { InboxView } from './index';
import notificationService from '../../services/notificationService';

const CVOInboxView = () => {
  const [inboxNotifications, setInboxNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCVOInbox();
  }, []);

  const fetchCVOInbox = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await notificationService.getCVOInbox();
      
      if (result.success && result.data) {
        // Handle the API response structure: { status: true, data: [...] }
        const inboxData = result.data.status === true && Array.isArray(result.data.data) 
          ? result.data.data 
          : Array.isArray(result.data) 
            ? result.data 
            : [];
        
        // Transform API data to match InboxView expected format
        const transformedNotifications = inboxData.map((item) => ({
          id: item.id,
          complaint_id: item.complaint_id,
          complaint_no: item.complaint_no || '',
          complaintId: item.complaint_no || '', // For backward compatibility
          type: item.action_type || 'notification',
          message: item.title || '',
          date: item.created_at || '',
          read: false, // You may need to add a read field to the API response
          from: item.action_by || '',
          role: item.role || '',
          old_value: item.old_value,
          new_value: item.new_value,
        }));
        
        setInboxNotifications(transformedNotifications);
      } else {
        setError(result.message || 'Failed to fetch inbox data');
        setInboxNotifications([]);
      }
    } catch (err) {
      console.error('Error fetching CVO inbox:', err);
      setError(err.message || 'An error occurred while fetching inbox data');
      setInboxNotifications([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInboxClick = (notification) => {
    // Navigate to complaint details or open modal
    console.log('Inbox notification clicked:', notification);
  };

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-gray-500">Loading inbox...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-red-500">Error: {error}</div>
      </div>
    );
  }

  return (
    <InboxView
      inboxNotifications={inboxNotifications}
      onNotificationClick={handleInboxClick}
    />
  );
};

export default CVOInboxView;
